import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {catchError, finalize, switchMap, throwError} from 'rxjs';
import {Router} from '@angular/router';
import {inject} from '@angular/core';
import {StorageService} from '../services/storage.service';
import {RefreshDto} from '../../features/authentication/dtos/refresh.dto';
import {AuthenticationService} from '../../features/authentication/authentication.service';
import {LoginResponseDto} from '../../features/authentication/dtos/login-response.dto';
import {MemoryService} from '../services/memory.service';
import {LoadingService} from '../services/loading.service';
import {RedirectService} from '../services/redirect.service';

export const httpErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const storageService: StorageService = inject(StorageService);
  const authenticationService: AuthenticationService = inject(AuthenticationService);
  const memoryService: MemoryService = inject(MemoryService);
  const router: Router = inject(Router);
  const loadingService = inject(LoadingService);
  const redirectService = inject(RedirectService);

  loadingService.setLoading(true, req.url);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
        switch (error.status) {
          case 401:
            if (req.url.endsWith('/login')) {
              return throwError(() => error);
            }

            let refreshToken = memoryService.refreshToken;
            if (refreshToken == null || req.url.endsWith('/refresh-token')) {
              const url = router.url;
              const state = history.state;
              redirectService.set({url: url, state: state});

              router.navigate(['/login']);

              return throwError(() => error);
            }

            let refreshDto: RefreshDto = {refreshToken: refreshToken};
            return authenticationService.refresh(refreshDto).pipe(
              switchMap((loginResponseDto: LoginResponseDto) => {
                memoryService.refreshToken = loginResponseDto.refreshToken;
                memoryService.accessToken = loginResponseDto.accessToken;
                memoryService.isNewUser = loginResponseDto.isNew;
                memoryService.patientEmail = loginResponseDto.email;
                const accessTokenRequest = req.clone({
                  setHeaders: {
                    Authorization: `Bearer ${memoryService.accessToken}`
                  }
                });

                return next(accessTokenRequest);
              }),
              catchError((_) => {
                const url = router.url;
                const state = history.state;
                redirectService.set({url: url, state: state});

                router.navigate(['/login']);

                return throwError(() => undefined);
              })
            );

          default:
            return throwError(() => error);
        }
      }
    ),
    finalize(() => {
      loadingService.setLoading(false, req.url);
    })
  );
};

